import { defineMessages } from 'react-intl';

import { sharedMessages } from '@app/translations/sharedMessages';

export const paginationMessages = defineMessages({
  pagination: {
    id: 'pagination.pagination',
    defaultMessage: 'Pagination',
  },
  previousPage: {
    id: 'pagination.previousPage',
    defaultMessage: 'Previous page',
  },
  nextPage: {
    id: 'pagination.nextPage',
    defaultMessage: 'Next page',
  },
  currentPage: {
    id: 'pagination.currentPage',
    defaultMessage: 'Current page {page}',
  },
  page: sharedMessages.pageNumber,
});
